var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chats"}},_vm._l((_vm.sorted),function(chat){return _c('div',{staticClass:"chat"},[_c('router-link',{attrs:{"to":'/chat?id=' + chat.uid}},[_c('preview',{attrs:{"chat":chat}})],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }